import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import KindredLogo from '../../Common/Logos/KindredLogo';
import { themeColor } from '../../Theming';
import ExtensionInstallLink from './ExtensionInstallLink';
import Separator from './Separator';

const Container = styled.div`
  margin-bottom: 0px;
  display: block;
  justify-content: center;
  width: 100%;
`;

const LogoContainer = styled.div`
  padding-bottom: 30px;
  position: relative;
`;

const HeadingContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const Heading = styled.h1`
  width: 90%;
  font-style: normal;
  font-weight: 700;
  font-size: 40px;
  line-height: 45px;
  text-align: center;
`;

const StyledExtensionInstallLink = styled(ExtensionInstallLink)`
  color: ${themeColor('darkestGrey')};
`;

interface MinimalHeaderProps {
  uninstallHeading?: boolean;
}

const MinimalHeader: React.FC<MinimalHeaderProps> = ({ uninstallHeading }) => {
  const { t } = useTranslation();

  return (
    <Container>
      <LogoContainer>
        <KindredLogo />
      </LogoContainer>

      {uninstallHeading && (
        <HeadingContainer>
          <Heading>
            {t('extension.uninstalled.title')}{' '}
            {t('extension.uninstalled.uninstalledByAccident')}{' '}
            <StyledExtensionInstallLink
              buttonText={t('extension.uninstalled.reinstall')}
            />
          </Heading>
        </HeadingContainer>
      )}
      <Separator />
    </Container>
  );
};

export default MinimalHeader;
